<button class="menu-mobile-hamburger" (click)="toggleMenu()">
  <i class="pi pi-bars"></i>
</button>

<div class="menu-mobile-backdrop" *ngIf="menuOpen" (click)="toggleMenu()"></div>

<nav class="menu-mobile-container" [class.open]="menuOpen">
  <div class="menu-mobile-header">
    <div class="menu-mobile-avatar"><i class="pi pi-user"></i></div>
    <div class="menu-mobile-title">
      Olá,
      {{ user?.name || "visitante" }}
    </div>
  </div>

  <button class="menu-mobile-att-toggle" (click)="toggleAtt()">
    <div class="menu-mobile-att-label">
      <i class="pi pi-question-circle"></i>
      Atendimento
    </div>
    <i class="pi" [ngClass]="attOpen ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
  </button>

  <div class="menu-mobile-att-block" [class.open]="attOpen">
    <div class="menu-mobile-att-card">
      <div
        (click)="onClickWhatsApp()"
        class="menu-mobile-att-row menu-mobile-att-row-whats"
      >
        <i class="pi pi-whatsapp"></i>
        <div>
          <div>Fale no WhatsApp</div>
          <strong>(48) 3369-7157</strong>
        </div>
      </div>

      <div class="menu-mobile-att-row">
        <i class="pi pi-envelope"></i>
        <div>
          <div>Envie um e-mail</div>
          <strong>comercial&#64;rmpolicarbonatos.com.br</strong>
        </div>
      </div>

      <div class="menu-mobile-att-hours">
        SEGUNDA - SEXTA<br />
        8h00 às 11:30 - 13:30 às 17:30
      </div>
    </div>
  </div>

  <div class="menu-mobile-section">
    <h4>Navegue por categoria</h4>

    <ul class="menu-mobile-list">
      <li *ngFor="let c of categories" class="menu-mobile-item-group">
        <button class="menu-mobile-item" (click)="toggleSub(safeId(c.id))">
          {{ c.description }}
          <i
            class="pi"
            [ngClass]="
              submenu[safeId(c.id)] ? 'pi-chevron-up' : 'pi-chevron-down'
            "
          ></i>
        </button>

        <ul class="menu-mobile-submenu" [class.open]="submenu[safeId(c.id)]">
          <li
            class="menu-mobile-subitem"
            *ngFor="let s of c.subCategories"
            (click)="go('/' + toSlug(c.id) + '/' + toSlug(s.id))"
          >
            {{ s.description }}
          </li>
        </ul>
      </li>
    </ul>
  </div>
</nav>
